<template>
  <div>
    <div class="team-wrapper" v-if="shopnameSet && (shopIsActive || shopOwner)">
      <ShopHeader
          :shopinfo="shopObj"
          :isOwner="shopOwner"
      />

      <div v-if="authendicated">

      <!--      <ShopFilterMenue :isOwner="shopOwner"/>-->

            <main class="shop__content">
              <NuxtPage
                  :shop="shopObj"
                  :isOwner="shopOwner"
              />
            </main>

            <PopupContainer/>
            <ModuleShopPopupMessages/>
            <ModuleOKOKCancelDialog/>
      </div>
      <div v-else>
        <AccessDenied :show-login="true"/>
      </div>

      <ShopFooter v-if="linksLoaded" :isOwner="shopOwner"/>
    </div>
    <div class="team-wrapper" v-if="!shopnameSet || (!shopIsActive && !shopOwner)">
      <ShopNotAvailable/>
    </div>
  </div>
</template>

<script lang="ts" setup>


import {EventListener, EventVerteiler} from "@k/global/eventVerteiler";
import "~/assets/scss/style.scss"
import {InterframeCommunicator} from "@k/global/frameCommunicator";
import {UserManagementConnectorRoutes} from "@k/global/UserManagementConnectorRoutes";
import {useStore} from "vuex";
import {useShopInfos} from "~/store/shopInfosStore";
import {Navigation_opencomponentHandler_SHOP} from "~/navigation_opencomponentHandler_SHOP";
import {initI18n} from "~/init/init_i18n";
import {initEventListeners} from "~/init/initEventListeners";
import {initSession} from "~/init/initSession";
import {loadInitialItemsAndPages, loadInitialShopInfo} from "~/init/loadInitialData";
import {loadWebsitelinks} from "~/init/loadWebsitelinks";
import "vanilla-cookieconsent";
import {CookieBannerhandler} from "@k/global/cookieconsent/cookieConsent";
import {setBUILD_ID} from "@k/global/globalUtils";
import {redirectToCanonicalURL, redirectToThirdLevelDomain} from "~/init/canonicalURL";
import ModuleOKOKCancelDialog from "@km/components/popups/ModuleOKOKCancelDialog.vue";
import {LinksToWebsiteShop, useFooterStore} from "~/store/FooterStore";

export type EnumDictionary<T extends string | symbol | number, U> = {
  [K in T]: U;
};


function getLanguageFromShopPfad(shopdirectoryLocalized: string, host:string, path : string) {
  switch (shopdirectoryLocalized) {
    case "shop":
      if(host.includes("owayo.nl")>0 || path.includes("lang=nl")>0){
        return "nl";
      }
      return "de";
    case "boutique":
      return "fr";
    case "tienda":
      return "es";
    case "negozio":
      return "it";
    case "store":
    case "store_test":
      if(host.includes("owayo.com")>0 || path.includes("lang=us")>0){
        return "us";
      }
      // if(host.includes("owayo.ca")>0 || path.includes("lang=ca")>0){
      //   return "ca";
      // }
      return "en"
    case "butikk":
      return "no";
    default:
      console.log("shopdirectoryLocalized not found: "+shopdirectoryLocalized+" host: "+host+" path: "+path);
      return "de";
  }
}




function domainOrShopDirectoryLocalizedDoesNotMatchShop(languageFromShopDirectoryLocalized: string) {
  const shopInfos = useShopInfos();
  let doesNotMatch = (shopInfos.getShopLand.toLowerCase() !== shopInfos.getDomainLand.toLowerCase()) || (shopInfos.getShopSprache.toLowerCase() !== languageFromShopDirectoryLocalized.toLowerCase());
  return doesNotMatch;
}

    setBUILD_ID();
    const route = useRoute();
    if (route.params.shopname as undefined | string === undefined) {
      // throw createError funktioniert in Dev und Production scheinbar unterschiedlich - in Dev macht er was man erwartet, in Production triggern zuest serverseitige Fehler die die weitere Ausführung behindern
      // throw createError({
      //   statusCode: 404,
      //   message: 'no shopname specified',
      //   fatal: true
      // })
    }
    onUnmounted(() => EventVerteiler.unsubscribe(eventListener));
    onMounted(function () {
      InterframeCommunicator.initWindowListener();
      CookieBannerhandler.init(i18n.t);
      initEventListeners(eventListener, vuexStore, loggedIn, i18n);
      initSession(vuexStore, i18n, loggedIn);
    });
    const requestURL = useRequestURL();
    const language = getLanguageFromShopPfad((route.params.shopdirectoryLocalized as string | undefined) || "shop", requestURL.host, route.fullPath);
    useHead({htmlAttrs: {lang: language}});

    UserManagementConnectorRoutes.initLanguage(language==='us' || language==='ca' ?'en':language);
    const vuexStore = useStore();
    const i18n = await initI18n(language);

    const loggedIn = ref(false);
    const eventListener = new EventListener();
    const linksLoaded = ref(false);

    await loadInitialShopInfo();
    const shopInfos = useShopInfos();
    const footerstore = useFooterStore();

      if(shopInfos.isShopActive === true){
        if (domainOrShopDirectoryLocalizedDoesNotMatchShop(language)) {
          await redirectToCanonicalURL(shopInfos.getShopSprache, shopInfos.getShopLand, shopInfos.shopname);
        }

        if (import.meta.env.PROD){
          if(!requestURL.host.startsWith('www.')){
            await redirectToThirdLevelDomain(requestURL.host+route.fullPath) ;
          }
        }

        await loadInitialItemsAndPages(shopInfos.shopname, shopInfos.getShopSprache, shopInfos.getShopLand);

        console.log('language for link loading: '+language);
        await loadWebsitelinks(language);
        Navigation_opencomponentHandler_SHOP.setShopInfoStore(shopInfos);
      }

      watch(
          () => footerstore.getLinksLoaded,
          (val) => {
            if (val === true) {
              console.log("links loaded (flag from store)");
              linksLoaded.value = true;
            }
          },
          { immediate: true }
      );

      const shopObj = computed(() => shopInfos.shopInfo);
      const shopOwner = computed(() => shopInfos.isShopOwner);
      const shopName = computed(() => shopInfos.shopname);
      const shopIsActive = computed(() => shopInfos.isShopActive);
      const username = computed(() => vuexStore.getters.getUsername);
      const shoppingcart = computed(() => vuexStore.getters.getWarenkorbPos);
      // const loggedInComp = computed(() => vuexStore.getters.isLoggedIn);
      const shopnameSet = computed(() => route.params.shopname as string | undefined !== undefined);
      const authendicated = computed(() => (shopInfos.isAuthenticated || shopInfos.isShopOwner));



</script>

<style lang="scss" scoped>
.modal-wrapper {
  background: rgba(255, 255, 255,0.9);
}

</style>
